import React from 'react';
import voiceAgentLogoImage from '../../../../images/VoiceAgent.png';
import chatAgentLogoImage from '../../../../images/ChatAgent.png';
import aiWorkerLogoImage from '../../../../images/ai_worker_logo_inline_light.png';
import { css } from '@emotion/react';

type HeroLogoProps = {
  size: number;
};

export const HeroLogo = React.memo(({ size }: HeroLogoProps) => {
  return (
    <div
      role="img"
      aria-label="AI Worker hero logo"
      css={css`
        width: ${size}px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
      `}
    >
      <img
        src={aiWorkerLogoImage}
        alt="AI Worker"
        css={css`
          width: 100%;
          aspect-ratio: 4 / 1;
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      />

      <div
        css={css`
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 10%;
        `}
      >
        <img
          src={chatAgentLogoImage}
          alt="Chat Agent"
          css={css`
            width: 30%;
            aspect-ratio: 6 / 1;
            display: flex;
            align-items: center;
            justify-content: center;
          `}
        />
        <img
          src={voiceAgentLogoImage}
          alt="Voice Agent"
          css={css`
            width: 30%;
            aspect-ratio: 6 / 1;
            display: flex;
            align-items: center;
            justify-content: center;
          `}
        />
      </div>
    </div>
  );
});
HeroLogo.displayName = 'HeroLogo';
